import { Stack, Typography, Box } from '@mui/material';
import { Project, ViewMode } from '../types/dashboard.types';
import { ProjectGrid } from '../components/ProjectGrid';
import { ProjectList } from '../components/ProjectList';
import { EmptyState } from '../components/EmptyState';
import { ProjectGridSkeleton } from '../components/DashboardSkeletons';
import { FolderOpen } from '@mui/icons-material';

interface ProjectsSectionProps {
  projects: Project[];
  viewMode: ViewMode;
  isLoading: boolean;
  isEmpty: boolean;
  onConfirm: (data?: any) => void;
  onOpen: (projectId: string, projectType: "draft" | "publish") => void;
  onRename: (projectId: string, projectName: string) => void;
  onDuplicate: (projectId: string) => void;
  onDelete: (projectId: string, projectName: string) => void;
}

export const ProjectsSection: React.FC<ProjectsSectionProps> = ({
  projects,
  viewMode,
  isLoading,
  isEmpty,
  onConfirm,
  onOpen,
  onRename,
  onDuplicate,
  onDelete,
}) => {

  return (
    <Stack spacing={2}>
      <Box>
        <Typography
          variant="h5"
          sx={{
            fontWeight: 600,
            color: 'var(--fx-surface-text, #0F172A)',
            marginBottom: 0.5,
          }}
        >
          Recent Projects
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: 'var(--fx-surface-textsecondary, #64748B)',
          }}
        >
          {isLoading ? 'Loading...' : `${projects.length} project${projects.length !== 1 ? 's' : ''}`}
        </Typography>
      </Box>

      {isLoading ? (
        <ProjectGridSkeleton />
      ) : isEmpty ? (
        <EmptyState
          title="No projects yet"
          description="Create your first site to get started. You can build from scratch, choose a template, or duplicate from a published project."
          actionLabel="Create first site"
          onAction={() => {
            onConfirm({ type: "chooseTemplate", isOpen: true });
          }}
          icon={<FolderOpen sx={{ fontSize: 40 }} />}
        />
      ) : viewMode === 'grid' ? (
        <ProjectGrid
          projects={projects}
          onOpen={onOpen}
          onRename={onRename}
          onDuplicate={onDuplicate}
          onDelete={onDelete}
        />
      ) : (
        <ProjectList
          projects={projects}
          onOpen={onOpen}
          onRename={onRename}
          onDuplicate={onDuplicate}
          onDelete={onDelete}
        />
      )}
    </Stack>
  );
};
